// File contenente le traduzioni per l'interfaccia utente
export const uiTranslations = {
  it: {
    // Traduzioni esistenti
    model: "Modello",
    selectModel: "Seleziona modello",
    selectedNow: "Selezionato ora",
    code: "cod.",

    // Traduzioni per FamilySelector
    family: "Categoria",
    selectFamily: "Seleziona la categoria",
    loadingProducts: "Caricamento prodotti in corso...",
    noFamiliesInCategory: "Nessuna gamma in questa categoria",
    noCategories: "Nessuna categoria disponibile",

    // Traduzioni per Accordion (materiali)
    standard: "standard",
    optional: "opzionale",
    select: "Seleziona",
    standardFinishes: "standard",
    optionalFinishes: "opzionali",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Predefinito",
      "Tessuti per termoformato": "Tessuti per termoformato",
      Verniciati: "Verniciati",
      Melaminici: "Melaminici",
      Legni: "Legni",
      Metalli: "Metalli",
      Plastiche: "Plastiche",
      melaminico: "Melaminico Laccato",
      "melaminico  legno": "Melaminico",
      metallo: "Metallo - Vernice a polvere",
      legno: "Legno",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Struttura",
      ripiani: "Ripiani",
      imbottito: "Tessuti",
      schienale: "Schienale",
      piano: "Piano",
      inserti: "Inserti",
      plastica: "Plastica",
      top: "Top",
      alluminio: "Alluminio",
      cassetti: "Cassetti",
      canalina: "Canalina",
      ruote: "Ruote",
    },

    // Traduzioni per la sezione Info
    infoSection: {
      usageImages: "Come potresti utilizzare le immagini",
      relatedProducts: "Potrebbe piacerti anche",
      addToCart: "Aggiungi al carrello",
      deliveryTime: "10-12 settimane",
    },

    // Traduzioni per demo
    requestDemo: "Richiedi demo",

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Preventivo",
      basePrice: "Prezzo Base",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Sovrapprezzo (15%)",
      // surchargeNote: "Il sovrapprezzo per materiali opzionali è fisso al 15% del prezzo base.",
      pricesWithoutVAT: "Prezzi senza IVA",
      startingFrom: "a partire da",
      contactUs: "Contattaci",
      requestQuote: "Richiedi Preventivo",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "Per ulteriori informazioni e quotazioni:",
      phone: "+39 02 7201 6336",
      emailSales: "vendite@moroso.com",
      emailMarketing: "marketing@moroso.com",
    },

    // Traduzioni PDF
    pdf: {
      collection: "COLLEZIONE",
      code: "CODICE",
      finishes: "FINITURE",
      startingFrom: "A PARTIRE DA",
      companyName: "nudesign srl",
      email: "info@nudesign.it",
      website: "www.nudesign.it",
      phone: "t +39 0432 92386",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Richiesta Preventivo Personalizzato",
      productDetails: "Dettagli Prodotto",
      category: "Categoria",
      selectedMaterials: "Materiali Selezionati",
      standardMaterial: "Standard",
      optionalMaterial: "Opzionale",
      personalData: "I Tuoi Dati",
      additionalNotes: "Note Aggiuntive",
      additionalNotesPlaceholder:
        "Specifiche aggiuntive, quantità, tempistiche di consegna...",
      name: "Nome",
      surname: "Cognome",
      email: "Email",
      phone: "Telefono",
      company: "Azienda",
      message: "Messaggio",
      cancel: "Annulla",
      submit: "Invia Richiesta",
      submitting: "Invio in corso...",
      successTitle: "Richiesta Inviata!",
      successMessage:
        "Grazie per la tua richiesta. Ti contatteremo al più presto per un preventivo personalizzato.",
      generatePDF: "Genera PDF Riassuntivo",
      downloadPDF: "Scarica PDF",
      pdfGenerated: "PDF generato con successo",

      // Messaggi automatici
      autoMessage: {
        greeting: "Salve,",
        intro: "sono interessato/a al seguente prodotto e configurazione:",
        productInfo: "DETTAGLI PRODOTTO:",
        materialsInfo: "MATERIALI SELEZIONATI:",
        priceInfo: "INFORMAZIONI PREZZO:",
        closing:
          "Vi prego di contattarmi per maggiori informazioni e per ricevere un preventivo dettagliato.",
        thanks: "Cordiali saluti",
      },
    },
  },
  en: {
    // Traduzioni esistenti
    model: "Model",
    selectModel: "Select model",
    selectedNow: "Currently selected",
    code: "code",

    // Traduzioni per FamilySelector
    family: "Family",
    selectFamily: "Select family",
    loadingProducts: "Loading product structure...",
    noFamiliesInCategory: "No families in this category",
    noCategories: "No categories available",

    // Traduzioni per Accordion (materiali)
    standard: "standard",
    optional: "optional",
    select: "Select",
    standardFinishes: "Standard",
    optionalFinishes: "Optional",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Default",
      "Tessuti per termoformato": "Thermoformed fabrics",
      Verniciati: "Painted",
      Melaminici: "Melamine",
      Legni: "Woods",
      Metalli: "Metals",
      Plastiche: "Plastics",
      "melaminico  legno": "Melamine",
      melaminico: "Melamine",
      metallo: "Metal",
      legno: "Wood",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Structure",
      ripiani: "Shelves",
      imbottito: "Fabrics",
      schienale: "Backrest",
      piano: "Top",
      inserti: "Inserts",
      plastica: "Plastic",
      top: "Top",
      alluminio: "Aluminum",
      cassetti: "Drawers",
      canalina: "Cable tray",
      ruote: "Wheels",
    },

    // Traduzioni per la sezione Info
    infoSection: {
      usageImages: "How you could use the images",
      relatedProducts: "You might also like",
      addToCart: "Add to cart",
      deliveryTime: "10-12 weeks",
    },

    // Traduzioni per demo
    requestDemo: "Request demo",

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Estimate",
      basePrice: "Base Price",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Surcharge (15%)",
      // surchargeNote: "Surcharge for optional materials is fixed at 15% of the base price.",
      pricesWithoutVAT: "Prices without VAT",
      startingFrom: "starting from",
      contactUs: "Contact Us",
      requestQuote: "Request Quote",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "For more information and quotes:",
      phone: "+39 02 7201 6336",
      emailSales: "sales@moroso.com",
      emailMarketing: "marketing@moroso.com",
    },

    // PDF translations
    pdf: {
      collection: "COLLECTION",
      code: "CODE",
      finishes: "FINISHES",
      startingFrom: "STARTING FROM",
      companyName: "nudesign srl",
      email: "info@nudesign.it",
      website: "www.nudesign.it",
      phone: "t +39 0432 92386",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Custom Quote Request",
      productDetails: "Product Details",
      category: "Category",
      selectedMaterials: "Selected Materials",
      standardMaterial: "Standard",
      optionalMaterial: "Optional",
      personalData: "Your Information",
      additionalNotes: "Additional Notes",
      additionalNotesPlaceholder:
        "Additional specifications, quantities, delivery timelines...",
      name: "Name",
      surname: "Surname",
      email: "Email",
      phone: "Phone",
      company: "Company",
      message: "Message",
      cancel: "Cancel",
      submit: "Send Request",
      submitting: "Sending...",
      successTitle: "Request Sent!",
      successMessage:
        "Thank you for your request. We will contact you soon for a personalized quote.",
      generatePDF: "Generate Summary PDF",
      downloadPDF: "Download PDF",
      pdfGenerated: "PDF generated successfully",

      // Messaggi automatici
      autoMessage: {
        greeting: "Hello,",
        intro: "I am interested in the following product and configuration:",
        productInfo: "PRODUCT DETAILS:",
        materialsInfo: "SELECTED MATERIALS:",
        priceInfo: "PRICE INFORMATION:",
        closing:
          "Please contact me for more information and to receive a detailed quote.",
        thanks: "Best regards",
      },
    },
  },
  fr: {
    // Traduzioni esistenti
    model: "Modèle",
    selectModel: "Sélectionner un modèle",
    selectedNow: "Actuellement sélectionné",
    code: "code",

    // Traduzioni per FamilySelector
    family: "Gamme",
    selectFamily: "Sélectionner la gamme",
    loadingProducts: "Chargement des produits...",
    noFamiliesInCategory: "Aucune gamme dans cette catégorie",
    noCategories: "Aucune catégorie disponible",

    // Traduzioni per Accordion (materiali)
    standard: "standard",
    optional: "optionnel",
    select: "Sélectionner",
    standardFinishes: "standard",
    optionalFinishes: "optionnelles",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Par défaut",
      "Tessuti per termoformato": "Tissus thermoformés",
      Verniciati: "Peints",
      Melaminici: "Mélamine",
      Legni: "Bois",
      Metalli: "Métaux",
      "melaminico  legno": "Mélamine",
      Plastiche: "Plastiques",
      melaminico: "Mélamine",
      metallo: "Métal",
      legno: "Bois",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Structure",
      ripiani: "Étagères",
      imbottito: "Tissus",
      schienale: "Dossier",
      piano: "Plateau",
      inserti: "Inserts",
      plastica: "Plastique",
      top: "Dessus",
      alluminio: "Aluminium",
      cassetti: "Tiroirs",
      canalina: "Conduit de câble",
      ruote: "Roues",
    },

    // Traduzioni per la sezione Info
    infoSection: {
      usageImages: "Comment utiliser les images",
      relatedProducts: "Vous pourriez aussi aimer",
      addToCart: "Ajouter au panier",
      deliveryTime: "10-12 semaines",
    },

    // Traduzioni per demo
    requestDemo: "Demander une demo",

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Devis",
      basePrice: "Prix de base",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Supplément (15%)",
      // surchargeNote: "Le supplément pour les matériaux optionnels est fixe à 15% du prix de base.",
      pricesWithoutVAT: "Prix hors TVA",
      startingFrom: "à partir de",
      contactUs: "Nous Contacter",
      requestQuote: "Demander un Devis",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "Pour plus d'informations et devis:",
      phone: "+39 02 7201 6336",
      emailSales: "sales@moroso.com",
      emailMarketing: "marketing@moroso.com",
    },

    // PDF translations
    pdf: {
      collection: "COLLECTION",
      code: "CODE",
      finishes: "FINITIONS",
      startingFrom: "À PARTIR DE",
      companyName: "nudesign srl",
      email: "info@nudesign.it",
      website: "www.nudesign.it",
      phone: "t +39 0432 92386",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Demande de Devis Personnalisé",
      productDetails: "Détails du Produit",
      category: "Catégorie",
      selectedMaterials: "Matériaux Sélectionnés",
      standardMaterial: "Standard",
      optionalMaterial: "Optionnel",
      personalData: "Vos Informations",
      additionalNotes: "Notes Supplémentaires",
      additionalNotesPlaceholder:
        "Spécifications supplémentaires, quantités, délais de livraison...",
      name: "Prénom",
      surname: "Nom",
      email: "Email",
      phone: "Téléphone",
      company: "Entreprise",
      message: "Message",
      cancel: "Annuler",
      submit: "Envoyer la Demande",
      submitting: "Envoi en cours...",
      successTitle: "Demande Envoyée!",
      successMessage:
        "Merci pour votre demande. Nous vous contacterons bientôt pour un devis personnalisé.",
      generatePDF: "Générer un PDF Récapitulatif",
      downloadPDF: "Télécharger PDF",
      pdfGenerated: "PDF généré avec succès",

      // Messaggi automatici
      autoMessage: {
        greeting: "Bonjour,",
        intro:
          "je suis intéressé(e) par le produit et la configuration suivants:",
        productInfo: "DÉTAILS DU PRODUIT:",
        materialsInfo: "MATÉRIAUX SÉLECTIONNÉS:",
        priceInfo: "INFORMATIONS PRIX:",
        closing:
          "Veuillez me contacter pour plus d'informations et pour recevoir un devis détaillé.",
        thanks: "Cordialement",
      },
    },
  },
  de: {
    // Traduzioni esistenti
    model: "Modell",
    selectModel: "Modell auswählen",
    selectedNow: "Aktuell ausgewählt",
    code: "code",

    // Traduzioni per FamilySelector
    family: "Produktfamilie",
    selectFamily: "Produktfamilie auswählen",
    loadingProducts: "Produktstruktur wird geladen...",
    noFamiliesInCategory: "Keine Familien in dieser Kategorie",
    noCategories: "Keine Kategorien verfügbar",

    // Traduzioni per Accordion (materiali)
    standard: "standard",
    optional: "optional",
    select: "Auswählen",
    standardFinishes: "Standardaus",
    optionalFinishes: "Optionale",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Standard",
      "Tessuti per termoformato": "Thermogeformte Stoffe",
      Verniciati: "Lackiert",
      Melaminici: "Melamin",
      Legni: "Holz",
      Metalli: "Metalle",
      Plastiche: "Kunststoffe",
      "melaminico  legno": "Melamin",
      melaminico: "Melamin",
      metallo: "Metall",
      legno: "Holz",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Struktur",
      ripiani: "Regale",
      imbottito: "Polsterung",
      schienale: "Rückenlehne",
      piano: "Oberfläche",
      inserti: "Einsätze",
      plastica: "Kunststoff",
      top: "Oberseite",
      alluminio: "Aluminium",
      cassetti: "Schubladen",
      canalina: "Kabelkanal",
      ruote: "Räder",
    },

    // Traduzioni per la sezione Info
    infoSection: {
      usageImages: "Wie Sie die Bilder verwenden könnten",
      relatedProducts: "Das könnte Ihnen auch gefallen",
      addToCart: "In den Warenkorb",
      deliveryTime: "10-12 Wochen",
    },

    // Traduzioni per demo
    requestDemo: "Demo anfordern",

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Kostenvoranschlag",
      basePrice: "Grundpreis",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Aufpreis (15%)",
      // surchargeNote: "Der Aufpreis für optionale Materialien ist fest bei 15% des Grundpreises.",
      pricesWithoutVAT: "Preise ohne MwSt.",
      startingFrom: "ab",
      contactUs: "Kontakt",
      requestQuote: "Angebot Anfordern",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "Für weitere Informationen und Angebote:",
      phone: "+39 02 7201 6336",
      emailSales: "sales@moroso.com",
      emailMarketing: "marketing@moroso.com",
    },

    // PDF translations
    pdf: {
      collection: "KOLLEKTION",
      code: "CODE",
      finishes: "AUSFÜHRUNGEN",
      startingFrom: "AB",
      companyName: "nudesign srl",
      email: "info@nudesign.it",
      website: "www.nudesign.it",
      phone: "t +39 0432 92386",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Individuelle Angebotsanfrage",
      productDetails: "Produktdetails",
      category: "Kategorie",
      selectedMaterials: "Ausgewählte Materialien",
      standardMaterial: "Standard",
      optionalMaterial: "Optional",
      personalData: "Ihre Daten",
      additionalNotes: "Zusätzliche Hinweise",
      additionalNotesPlaceholder:
        "Zusätzliche Spezifikationen, Mengen, Lieferzeiten...",
      name: "Vorname",
      surname: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      company: "Unternehmen",
      message: "Nachricht",
      cancel: "Abbrechen",
      submit: "Anfrage Senden",
      submitting: "Wird gesendet...",
      successTitle: "Anfrage Gesendet!",
      successMessage:
        "Vielen Dank für Ihre Anfrage. Wir werden Sie bald für ein personalisiertes Angebot kontaktieren.",
      generatePDF: "Zusammenfassung PDF Generieren",
      downloadPDF: "PDF Herunterladen",
      pdfGenerated: "PDF erfolgreich generiert",

      // Messaggi automatici
      autoMessage: {
        greeting: "Hallo,",
        intro:
          "ich interessiere mich für das folgende Produkt und die Konfiguration:",
        productInfo: "PRODUKTDETAILS:",
        materialsInfo: "AUSGEWÄHLTE MATERIALIEN:",
        priceInfo: "PREISINFORMATIONEN:",
        closing:
          "Bitte kontaktieren Sie mich für weitere Informationen und um ein detailliertes Angebot zu erhalten.",
        thanks: "Mit freundlichen Grüßen",
      },
    },
  },
}

// Funzione di supporto per ottenere le traduzioni nella lingua specificata
export const getTranslations = (language) => {
  return uiTranslations[language] || uiTranslations.it // Fallback all'italiano se la lingua non esiste
}
